import React, { useContext, useEffect, useRef, useState } from 'react';
import ProfilePicture from './ProfilePicture';
import { litigationFunderInfoSchema, professionalInfoSchema } from '../../Validations/User';
import { useFormik } from 'formik';
import axios from 'axios';
import InputElement from '../Element/InputElement';
import { Context } from '../../Context/Context';
import { APPROVELIST, ATTORNEYLIST, DEFAULTAVATAR, FUNDERAPPROVELIST, LICENSED, UNAPPROVELIST, generateSignedurlApi, isEmailAvailableApi, raiseNotificationApi, updateUserApi, updateUserProfessionalApi } from '../../Constants';
import AttorneyProfilePic from './AttorneyProfilePic';
import { ToastContainer, toast } from 'react-toastify';
import FormErrorBanner from '../Element/FormErrorBanner';
import FieldError from '../Element/FieldError';
import PreferenceFields from './PreferenceFields';
import { validateEmail } from 'Utils';
import { useNavigate } from 'react-router-dom';
import capitalize from 'capitalize';
import { stateUS } from 'states';

function LitigationFunderProfile({setShowEdit, showBack=true, showConsent=true}) 
{
  
  
  const {userDetails, setUserDetails, setUpdateLoggedinData, makeApiCallFunc} = useContext(Context);
  const [states, setStates] = useState(stateUS);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const {legalType} = userDetails; 
  const [attorneyError, setAttorneyError] = useState("");
  const attorneyImageRemoveRef = useRef(null);
  const [isEmailAvailable, setIsEmailAvailable] = useState();
   const [errorMsg, setErrorMsg] = useState({
          case: "",
          state: ""
      });

   
 
  const approveData = (values) => {
      const data = {};

      FUNDERAPPROVELIST.map((item) => { 
        console.log(item, values[item],userDetails[item]);

          if(values[item] !== userDetails[item])
          {
              data[item] = {
                "newValue" : values[item],
                "oldValue" : userDetails[item]
              }
          }
      });
      
      console.log(data)
      return data;
  }
  const unApproveData = () => {
    const data = {};
    UNAPPROVELIST.map((item) => {
      if(values[item] !== userDetails[item])
      {
        data[item] = values[item];
      }
    });
    data["casePref"] = casePref?.length !== 0 ? casePref  : [];
    data["statePref"] = statePref?.length !== 0 ? statePref  : [];

    return data;
  }
  const userUpdation = () => {
    const approvePostData = approveData(values);
    const unApprovePostData = unApproveData(values);

    console.log("Submitting user data for approval:", approvePostData);
    console.log("Submitting user data for update:", unApprovePostData);
    makeApiCallFunc(
      updateUserProfessionalApi, 
      {
        toBeApproved : Object.entries(approvePostData)?.length ? {...approvePostData, profilePic: '',user: userDetails._id, "isUserAssistant": false} : null,
        user: userDetails._id,
        toBeUnapproved : Object.entries(unApprovePostData)?.length ? {...unApprovePostData, user: userDetails._id, "isUserAssistant": false} : null,
      },
      ({data}) => {
          toast.success("Sent the updated information to admin for approval");
          if(!showBack)
            {
            setUpdateLoggedinData(prev => !prev);
                
                navigate('/attorney/profile') }
          else
          {
            setUpdateLoggedinData(prev => !prev);
            setShowEdit(false);
          }
      }
      )
  }
  const onSubmit  = () => {
    userUpdation();
  }
  const handleFocus = (e) => 
  {
    setApiError("");
  }


   const [apiError, setApiError] = useState("");
   const [casePref, setCasePref] = useState(userDetails?.casePref ? userDetails?.casePref : null);
   const [statePref, setStatePref] = useState(userDetails?.statePref ? userDetails?.statePref :null);

   const initialValue = {
    email: userDetails?.email ? userDetails?.email : "",
    firstName :userDetails?.firstName ? userDetails?.firstName : "",
    lastName :userDetails?.lastName ? userDetails?.lastName : "",
    company :userDetails?.company ? userDetails?.company : "",
    experience :userDetails?.experience ? userDetails?.experience : "",
    legalType :userDetails?.legalType? userDetails?.legalType: "Litigation Funder",
    lawFirmLink: userDetails?.lawFirmLink ? userDetails?.lawFirmLink : "",
    casePref :  userDetails?.casePref ? userDetails?.casePref : "",
    statePref : userDetails?.statePref ? userDetails?.statePref : "",
    authorizedConsent : showConsent ? false : true
}
   const {values, errors, touched, handleBlur, setFieldValue,handleChange, handleSubmit, isSubmitting} = useFormik({
      enableReinitialize: true,
      initialValues : initialValue,
      validationSchema : litigationFunderInfoSchema,
      onSubmit,
  })
   
  
  return (
    <div className='p-2 lg:p-10 w-full bg-white'>
      
      <FormErrorBanner>{apiError}</FormErrorBanner>
      <div className='flex w-full flex-col lg:flex-row mb-2 ' >
        
        <div className='w-full'>
          <InputElement
              handleChange={(e) =>setFieldValue("firstName", capitalize(e.target.value))}
              handleBlur={handleBlur}
              handleFocus={handleFocus}
              label = "First name"
              name = "firstName"
              placeholder= "--Enter your first name--"
              value = {values.firstName}
              labelError={errors.firstName}
              labelTouched={touched.firstName}
              ignoreLabel={false}
          />
        </div>
        <div className='w-full lg:ml-2'>
          <InputElement 
                handleChange={(e) => setFieldValue("lastName", capitalize(e.target.value))}
                handleBlur={handleBlur}
                handleFocus={handleFocus}
                label = "Last name"
                name = "lastName"
                placeholder= "--Enter your last name--"
                value = {values.lastName}
                labelError={errors.lastName}
                labelTouched={touched.lastName}
            />
        </div>
      </div>
         <div className='flex w-full mt-6  flex-col lg:flex-row mb-2 ' >
        
        <div className='w-full'>
              <InputElement 
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder = "--Enter the name of the litigation funder entity--"
                  name = "company"
                  label= "Name of litigation funder entity"
                  value = {values.company}
                  labelError={errors.company}
                  labelTouched={touched.company}
                />
          </div>
           <div className=' w-full lg:ml-2'>
              <InputElement 
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  placeholder = "--Enter the litigation funder website link--"
                  name = "lawFirmLink"
                  label= "Litigation funder website link"
                  value = {values.lawFirmLink}
                  labelError={errors.lawFirmLink}
                  labelTouched={touched.lawFirmLink}
                />
          </div>
        </div>
        <div className='w-full'>

          <div>
             <label className='block font-bold mt-6 flex-1 ml-1 mt-2 text-sm leading-6 text-gray-900 mb-2'>
                How many years has the litigation funder been in business?
                <span className='text-gray-500 font-normal italic text-xs'>
                  (optional)
                </span>
             </label>
             <InputElement
               handleChange={handleChange}
               handleBlur={handleBlur}
               handleFocus={handleFocus}
               placeholder = "--Enter the number of years--"
               name = "experience"
               value = {values.experience}
               labelError={errors.experience}
               labelTouched={touched.experience}
             />
          </div>
        </div>
         
      <div className='w-full  '>
        

        <PreferenceFields states={states}
        casePref={casePref}
        statePref={statePref}
        setCasePref={setCasePref}
        setStatePref={setStatePref}
        setErrorMsg={setErrorMsg}
        errorMsg={errorMsg}
        isRequired={false}
        />
       
        
      </div> 
      

      { showConsent &&
      <>
      <div className="flex items-center mt-6 justify-left">
            <input 
                id="checkbox" 
                type="checkbox" 
                checked= {values.authorizedConsent}
                onChange={handleChange}
                name = "authorizedConsent"
                onBlur={handleBlur}
                className="border-gray-100 focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 rounded bg-white mr-2 ring-1 ring-inset ring-gray-300 h-[20px] w-[20px] accent-[#139cda]"
            />
            <label 
                for="checkbox"
                className="font-normal text-md "
                > I confirm that I am authorized by the litigation funder to create an account on www.quickcasereview.com and execute actions on their behalf.
                </label>
               
        </div>
       {errors.authorizedConsent && touched.authorizedConsent ? (
                    <FieldError>{errors.authorizedConsent}</FieldError>
                ): ""}
        </>
        }
        <div className={'flex mt-2 lg:mt-16 gap-2 text-md font-bold ' + (!showBack ? ' justify-center' : '  justify-between')}>
              <div 
                className="w-full lg:w-auto lg:px-24 h-10 bg-sky-500 hover:bg-sky-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl "
                onClick={handleSubmit}>
                  {userDetails.verified ? 
                  "Save updates"
                  :
                 ( showBack ? 
                  "Submit "
                :
                 "Submit For Review" 
                )
                  }
                  </div>
              {showBack ? <div 
              className="w-full lg:w-auto px-5 h-10 bg-gray-400 hover:bg-gray-600 text-white rounded mt-5 flex justify-center items-center cursor-pointer shadow-xl"
              onClick={()=>setShowEdit(false)} >Back</div>
            :
            ''}
        </div>
    </div>
   
  )
}


export default LitigationFunderProfile
